import React from 'react';

const DEFAULT_SIZE = 70;

export const TimeLapsIcon = ({ fill = '#E1F4D3', fillSecondary = '#1C452B', width = DEFAULT_SIZE, height = DEFAULT_SIZE, className, style, ...rest }) => {
  const sizeStyle = {
    width,
    height,
    minWidth: width,
    minHeight: height,
    flexShrink: 0,
    ...style,
  };
  return (
    <svg
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={sizeStyle}
      {...rest}>
      <g clipPath="url(#clip0_82_225)">
        <path
          d="M60.1569 29.5312C58.3413 29.5312 56.8757 28.0656 56.8757 26.25C56.8757 25.025 57.5538 23.9677 58.5527 23.4062C57.7579 21.8021 56.81 20.2927 55.7163 18.8927C55.1402 19.3813 54.4038 19.6875 53.5944 19.6875C51.7788 19.6875 50.3132 18.2219 50.3132 16.4062C50.3132 15.5896 50.6194 14.8604 51.1079 14.2844C49.7079 13.1979 48.1986 12.2427 46.5944 11.4479C46.0329 12.4469 44.9757 13.125 43.7507 13.125C41.935 13.125 40.4694 11.6594 40.4694 9.84375C40.4694 9.66875 40.4913 9.50104 40.5204 9.33333C38.7413 8.95417 36.8965 8.75 35.0007 8.75C34.7527 8.75 34.5121 8.76458 34.2642 8.77187C34.2569 9.51562 33.6882 10.1427 32.9371 10.2083C20.1913 11.2583 10.209 22.1521 10.209 35.0073C10.209 41.6281 12.7902 47.8552 17.4715 52.5365C22.1527 57.2177 28.3798 59.799 35.0007 59.799C47.8559 59.799 58.7423 49.8167 59.7996 37.0781C59.8652 36.3198 60.4704 35.751 61.2361 35.7438C61.2361 35.4958 61.2579 35.2552 61.2579 35.0073C61.2579 33.1115 61.0538 31.2667 60.6746 29.4875C60.5069 29.5167 60.3392 29.5385 60.1642 29.5385L60.1569 29.5312ZM50.3132 36.4583H35.0007C34.1986 36.4583 33.5423 35.8021 33.5423 35V19.6875C33.5423 18.8854 34.1986 18.2292 35.0007 18.2292C35.8027 18.2292 36.459 18.8854 36.459 19.6875V33.5417H50.3132C51.1152 33.5417 51.7715 34.1979 51.7715 35C51.7715 35.8021 51.1152 36.4583 50.3132 36.4583Z"
          fill={fill}
        />
        <path
          d="M34.9993 62.7082C49.3566 62.7082 61.5264 51.5519 62.7004 37.304C62.766 36.5019 62.1681 35.7946 61.366 35.729C61.3223 35.729 61.2712 35.729 61.2275 35.729C60.4618 35.729 59.8566 36.3051 59.791 37.0634C58.741 49.8092 47.8473 59.7842 34.9921 59.7842C28.3712 59.7842 22.1441 57.203 17.4629 52.5217C12.7816 47.8405 10.2004 41.6134 10.2004 34.9926C10.2004 22.1373 20.1827 11.2509 32.9285 10.1936C33.6868 10.128 34.2483 9.50089 34.2556 8.75714C34.2556 8.71339 34.2556 8.66235 34.2556 8.6186C34.19 7.81651 33.49 7.2186 32.6806 7.28422C18.4473 8.47276 7.29102 20.6426 7.29102 34.9998C7.29102 42.4009 10.1712 49.3571 15.4066 54.5926C20.6421 59.828 27.5983 62.7082 34.9993 62.7082Z"
          fill={fillSecondary}
        />
        <path
          d="M34.9993 18.2292C34.1973 18.2292 33.541 18.8855 33.541 19.6876V35.0001C33.541 35.8022 34.1973 36.4584 34.9993 36.4584H50.3118C51.1139 36.4584 51.7702 35.8022 51.7702 35.0001C51.7702 34.198 51.1139 33.5417 50.3118 33.5417H36.4577V19.6876C36.4577 18.8855 35.8014 18.2292 34.9993 18.2292Z"
          fill={fillSecondary}
        />
        <path
          d="M46.5938 11.4479C46.8635 10.974 47.0312 10.4271 47.0312 9.84375C47.0312 8.02813 45.5656 6.5625 43.75 6.5625C42.1094 6.5625 40.7677 7.76563 40.5198 9.33333C40.4906 9.50104 40.4688 9.66875 40.4688 9.84375C40.4688 11.6594 41.9344 13.125 43.75 13.125C44.975 13.125 46.0323 12.4469 46.5938 11.4479Z"
          fill={fillSecondary}
        />
        <path
          d="M55.7156 18.8927C56.4156 18.2875 56.875 17.4052 56.875 16.4062C56.875 14.5906 55.4094 13.125 53.5938 13.125C52.5948 13.125 51.7125 13.5771 51.1073 14.2844C50.6187 14.8604 50.3125 15.5969 50.3125 16.4062C50.3125 18.2219 51.7781 19.6875 53.5938 19.6875C54.4104 19.6875 55.1396 19.3812 55.7156 18.8927Z"
          fill={fillSecondary}
        />
        <path
          d="M60.1562 29.5312C60.3313 29.5312 60.499 29.5094 60.6667 29.4802C62.2344 29.2323 63.4375 27.8906 63.4375 26.25C63.4375 24.4344 61.9719 22.9688 60.1562 22.9688C59.5729 22.9688 59.026 23.1365 58.5521 23.4062C57.5531 23.9677 56.875 25.025 56.875 26.25C56.875 28.0656 58.3406 29.5312 60.1562 29.5312Z"
          fill={fillSecondary}
        />
      </g>
      <defs>
        <clipPath id="clip0_82_225">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
